"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Logodisplay() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const partners = [{
    name: "Anglo American",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_anglo_american.png"
  }, {
    name: "Glencore",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_glencore.png"
  }, {
    name: "Sibanye Stillwater",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_sibanye.png"
  }, {
    name: "Impala Platinum",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_implats.png"
  }, {
    name: "Exxaro",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_exxaro.png"
  }, {
    name: "Sasol Mining",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_sasol.png"
  }, {
    name: "Gold Fields",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_gold_fields.png"
  }, {
    name: "Harmony Gold",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_harmony.png"
  }, {
    name: "African Rainbow Minerals",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_arm.png"
  }, {
    name: "Petra Diamonds",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_petra.png"
  }];
  const loop = [...partners, ...partners];
  return;
}